import Accounts from './account/AccountForm';
import Artist from './artist/ArtistForm';
import AuthUser from './user/AuthUserForm';
import Statements from './statements/ExchangeRatesForm';
export default {
  Artist,
  Accounts,
  AuthUser,
  Statements,
};
